import useSWR from "swr";

import { usePublicAPI } from "../../services/apiService";
import type { BAAVersion } from "../../types/baa";
import { useBAAService } from "./useBAAService";

const BAA_CURRENT_KEY = "/baa/current";

export const useBAACurrentVersion = () => {
  const publicApi = usePublicAPI("v2");
  const baaService = useBAAService(publicApi);

  const { data, error, isLoading } = useSWR<BAAVersion>(
    BAA_CURRENT_KEY,
    () => baaService.getCurrentBAA(),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 1 * 24 * 60 * 60 * 1000, // 1 day
    }
  );

  return {
    baaVersion: data,
    isLoading,
    isError: error,
  };
};
